// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay Fragebogen */

.overlay-tripetto {
    position: fixed;
    top: 80px;
    left: 0;
    align-self: center;
    width: 100%;
    height: calc(100% - 80px);
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center; /* Align horizontally in the middle */
    align-items: center; /* Align vertically in the middle */
}

.overlay-iframe-container {
    position: relative;
    display: flex;
    height: 100%;
    background-color: var(--white-base);
    justify-content: center;
    align-items: center;
    align-self: center;
    max-width: 80%; /* Optional: Set a max-width for the container */
    padding: 0px 20px 0px 20px;
    border-radius: 20px;
    overflow-y: scroll;
    direction: rtl; /* Set the direction to right-to-left */
}

.overlay-iframe-container::-webkit-scrollbar {
    width: 12px; /* Adjust the scrollbar thickness as needed */
    height: 120px; /* Adjust the scrollbar thickness as needed */
}

.overlay-iframe-container::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0); /* Set your desired scrollbar color */
}

.overlay-iframe-1 {
    width: 100%;
    height: 100%;
    border: none;
    overflow: visible;
    border-radius: 15px;
}

.overlay-close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #ff6347;
    color: white;
    border: none;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 24px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index: 10;
}

.overlay-close-btn:hover {
    background-color: #e55347;
    transform: scale(1.1);
}

.overlay-close-btn::before {
    content: '\\00d7';
    font-size: 32px;
    line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/widgets/TripettoWidget.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,uBAAuB,EAAE,qCAAqC;IAC9D,mBAAmB,EAAE,mCAAmC;AAC5D;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,mCAAmC;IACnC,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc,EAAE,gDAAgD;IAChE,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,cAAc,EAAE,uCAAuC;AAC3D;;AAEA;IACI,WAAW,EAAE,6CAA6C;IAC1D,aAAa,EAAE,6CAA6C;AAChE;;AAEA;IACI,kCAAkC,EAAE,qCAAqC;AAC7E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB","sourcesContent":["/* Overlay Fragebogen */\r\n\r\n.overlay-tripetto {\r\n    position: fixed;\r\n    top: 80px;\r\n    left: 0;\r\n    align-self: center;\r\n    width: 100%;\r\n    height: calc(100% - 80px);\r\n    background: rgba(0, 0, 0, 0.5);\r\n    z-index: 999;\r\n    display: flex;\r\n    justify-content: center; /* Align horizontally in the middle */\r\n    align-items: center; /* Align vertically in the middle */\r\n}\r\n\r\n.overlay-iframe-container {\r\n    position: relative;\r\n    display: flex;\r\n    height: 100%;\r\n    background-color: var(--white-base);\r\n    justify-content: center;\r\n    align-items: center;\r\n    align-self: center;\r\n    max-width: 80%; /* Optional: Set a max-width for the container */\r\n    padding: 0px 20px 0px 20px;\r\n    border-radius: 20px;\r\n    overflow-y: scroll;\r\n    direction: rtl; /* Set the direction to right-to-left */\r\n}\r\n\r\n.overlay-iframe-container::-webkit-scrollbar {\r\n    width: 12px; /* Adjust the scrollbar thickness as needed */\r\n    height: 120px; /* Adjust the scrollbar thickness as needed */\r\n}\r\n\r\n.overlay-iframe-container::-webkit-scrollbar-thumb {\r\n    background-color: rgba(0, 0, 0, 0); /* Set your desired scrollbar color */\r\n}\r\n\r\n.overlay-iframe-1 {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n    overflow: visible;\r\n    border-radius: 15px;\r\n}\r\n\r\n.overlay-close-btn {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: #ff6347;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 35px;\r\n    height: 35px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    font-size: 24px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    z-index: 10;\r\n}\r\n\r\n.overlay-close-btn:hover {\r\n    background-color: #e55347;\r\n    transform: scale(1.1);\r\n}\r\n\r\n.overlay-close-btn::before {\r\n    content: '\\00d7';\r\n    font-size: 32px;\r\n    line-height: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
